module.exports = __webpack_public_path__ + "static/media/Anish Deshpande.f2d69fc1.jpg";